import { render, staticRenderFns } from "./IconNavigationAccount.vue?vue&type=template&id=aebf7032"
import script from "./IconNavigationAccount.vue?vue&type=script&lang=js"
export * from "./IconNavigationAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports